import React from 'react'
import {observer} from 'mobx-react'
import {useTranslation} from 'react-i18next'
import {Button, Col, Row, Typography} from 'antd'
import {DigitalReceiptsModal} from '..'
import {GoogleManagerTagClassNames} from '@/constants'

import {GoToDigitalReceiptsButtonProps} from './props'
import styles from './styles.scss'

export const GoToDigitalReceiptsButton = observer(({store}: GoToDigitalReceiptsButtonProps) => {
    const {t} = useTranslation()

    const handleClick = async () => {
        const newTab = window.open('', '_blank')

        if (!newTab) {
            return
        }

        const redirectUrl = await store.getDigitalReceiptsRedirectUrl()

        if (!redirectUrl) {
            newTab.close()
            return
        }

        newTab.location.href = redirectUrl
        store.openGoToModal()
    }

    return (
        <>
            <div className={styles.root}>
                <Button
                    className={GoogleManagerTagClassNames.digitalReceipts.goTo}
                    onClick={handleClick}
                    loading={store.isGoToLoading}
                    size='large'
                    type='default'
                >
                    <span className={GoogleManagerTagClassNames.digitalReceipts.goTo}>
                        {t('GoToDigitalReceipts.cta')}
                    </span>
                </Button>
            </div>

            <DigitalReceiptsModal
                open={store.isGoToModalOpen}
                onClose={store.closeGoToModal}
                footer={
                    <Button type='primary' size='large' onClick={store.closeGoToModal}>
                        {t('GoToDigitalReceipts.gotIt')}
                    </Button>
                }
            >
                <Row justify='center' align='middle' style={{textAlign: 'center'}}>
                    <Col xs={18}>
                        <Typography.Title level={3}>
                            {t('GoToDigitalReceipts.modalTitle')}
                        </Typography.Title>
                    </Col>
                    <Col xs={18}>
                        <Typography.Paragraph>
                            {t('GoToDigitalReceipts.modalDescription')}
                        </Typography.Paragraph>
                    </Col>
                </Row>
            </DigitalReceiptsModal>
        </>
    )
})
